export default __webpack_public_path__ + "static/media/sla3d.cd4a397c.png";